import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { TabelPaging } from '../../interfaces/table';
import {
  PCTableActionInputModel,
  PCTableFieldModel,
} from '../../models/pc-table-action-input-model';
import * as _ from 'lodash-es';
import { DatePipe } from '@angular/common';
import { ModalConfirm } from '../../models/modal-confirm';
import { Field } from '../../models/entity-defin';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';

@Component({
  selector: 'app-sale-pre-invoice',
  templateUrl: './sale-pre-invoice.component.html',
  styleUrl: './sale-pre-invoice.component.css',
})
export class SalePreInvoiceComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    private logger: LoggerService,
    private renderer: Renderer2,
    public datepipe: DatePipe,
    private responseService: CustomizeResponseService,
    private apiService: UserApiService
  ) {
    this.requestModel = new PCSearchRequestModel();

    this.action = new PCTableActionInputModel(
      [
        {
          name: 'AutomaticResolve',
          className: 'btn-outline-primary',
          icon: 'fas fa-exchange-alt',
        },
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      '',
      []
    );

    if (this.endPoint != null) {
      this.action.title = this.endPoint;
    }
  }

  public endPoint: string = 'SalePreInvoiceDetail';

  public data?: PCTableInputModel;
  public paging?: TabelPaging;
  public action: PCTableActionInputModel;
  public fields: Field[] = [];
  public modalFields: Field[] = [];
  public modalDeleteConfirm: boolean = false;
  public modalSuccessConfirm: boolean = false;
  public breadCrumb: string = '';

  public requestModel: PCSearchRequestModel;
  public endPointUrl!: string;
  public loading: boolean = false;
  public thisValue: any;
  @ViewChild('InventoryDetails') InventoryDetails!: ElementRef;
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;

  public confirmModal: ModalConfirm = new ModalConfirm();

  public ngOnInit(): void {
    if (this.endPoint == null) {
      this.logger.addError('Endpoint is required .....!!!', false);
      return;
    }

    this.action.title = this.endPoint;

    this.generateUrl();
    forkJoin([this.getData(), this.getEntity()]).subscribe(
      ([dataResult, entityResult]) => {
        if (dataResult) {
          this.logger.addResponseLog(this.endPointUrl, dataResult, `Get All`);
          if (dataResult.succeeded) {
            let firstItemOnPage = dataResult.data?.firstItemOnPage || 1;

            if (dataResult.data?.pageCount! < dataResult.data?.pageNumber! && dataResult.data?.pageCount!=0) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }
            this.data = new PCTableInputModel(
              dataResult.data?.items,
              [
                {
                  name: 'InventoryDetails',
                  className: 'btn-outline-primary',
                  icon: 'fas fa-boxes',
                  condition: 'hasInventory',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(dataResult);
          }
        }

        if (entityResult) {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            entityResult,
            `Get Entity`
          );
          if (entityResult.succeeded) {
            let fields = this.apiService.convertStringToBoolean(
              entityResult.data.fields
            );

            fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            this.fields = fields;
          }
        }

        setTimeout(() => {
          if (this.pcTableComponent) {
            this.pcTableComponent.InitPage();
          } else {
            console.error('PCTableComponent not found');
          }
        }, 2);

        setTimeout(() => {
          let selectStockPage = document.getElementById('selectStockPage');
          if (selectStockPage) {
            selectStockPage.classList.remove('animate__backInDown');
          }
        }, 2000);

        this.loading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
      }
    );
  }

  public getData() {
    return this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getSingleData() {
    try {
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = result.data?.firstItemOnPage || 1;

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }

            this.data = new PCTableInputModel(
              result.data?.items,
              [
                {
                  name: 'InventoryDetails',
                  className: 'btn-outline-primary',
                  icon: 'fas fa-boxes',
                  condition: 'hasInventory',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            const matTable = document.querySelector('.table-responsive');
            if (matTable != null) {
              matTable.scrollTop = 0;
            }

            this.paging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public AutomaticResolve() {
    try {
      const url = `${this.endPoint}/AutomaticResolve`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.loading = true;
      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.modalSuccessConfirm=true;
          this.getSingleData();
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          this.endPoint
        )
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public generateUrl() {
    this.endPointUrl = `${this.endPoint}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public createJson(inputElement: Field[]) {
    var backentJson = {};
    for (let index = 0; index < inputElement.length; index++) {
      const element = inputElement[index];

      backentJson[element.fieldName] = element.defaultValue;
    }
    return backentJson;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;

        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
          this.requestModel.orderBy = event.data;
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
          this.requestModel.orderBy = event.data;
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        } else {
          this.requestModel.direction = 'asd';
          this.requestModel.orderBy = '';
        }

        this.generateUrl();
        this.getSingleData();
        break;
      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Paging':
        this.loading = true;

        this.requestModel.pageNumber = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.generateUrl();
        this.getSingleData();
        break;

      case 'AutomaticResolve':
        this.loading = true;
        this.AutomaticResolve();
        break;

      case 'InventoryDetails':
        this.thisValue = event.data;
        this.openModal();
        break;

      case 'Close':
        this.thisValue = undefined;
        this.modalService.dismissAll();
        break;

      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;
      case 'SubmitSetting':
        this.fields = event.data;
        if (this.pcTableComponent) {
          this.pcTableComponent.RebuildColumn();
        } else {
          console.error('PCTableComponent not found');
        }
        break;
      default:
        break;
    }
  }

  public changeTime(value: any): string | null {
    var timeArray = value.split(':');
    var date = new Date();
    date.setHours(timeArray[0]);
    date.setMinutes(timeArray[1]);
    date.setSeconds(0);

    return this.datepipe.transform(date, 'HH:mm:ss');
  }

  public openModal() {
    try {
      this.modalService
        .open(this.InventoryDetails, {
          ariaLabelledBy: 'modal-basic-title',
          size: 'xl',
        })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
          },
          (reason) => {}
        );
    } catch (error) {
      this.logger.addException(error, false);
    }
  }

  public SubmitSetting() {
    if (this.pcTableComponent) {
      this.pcTableComponent.RebuildColumn();
      this.modalService.dismissAll();
    } else {
      console.error('PCTableComponent not found');
    }
  }
}
